import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/common';
import { PageURL } from 'router/pageURL';

export const UnauthorizedPage: React.FC = () => (
  <div className={'flex h-screen w-screen items-center justify-center'}>
    <div className={'relative h-2/3 w-2/3'}>
      <h3 className={'dark:text-d-black mb-8 w-2/3 text-6xl font-bold text-black'}>
        <FormattedMessage id={'unauthorized.title.header'} />
      </h3>
      <Link to={PageURL.ROOT} className={'no-underline'}>
        <Button variant={'contained'} color={'primary'} disableElevation>
          <FormattedMessage id={'cta.goBackHome'} />
        </Button>
      </Link>
    </div>
  </div>
);
